import { Component, Inject, OnInit, ViewChild  } from '@angular/core';
import { MatTableDataSource, MatPaginator, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { LeadService } from '../_leadcrmservices/lead.service';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Papa } from 'ngx-papaparse';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {

  siteList = [];
  leadCampList: any = [];

  reminderType: string = 'Email';

  smsTemplateList : any;
  emailTemplateList : any;
  smsGatewayList : any;
  emailGatewayList : any;
  smsContent: string = null;
  emailContent: string = null;

  
  searchForm = new FormGroup({
    site_id: new FormControl('', Validators.required),
    from_date: new FormControl(''),
    to_date: new FormControl(''),
    campaign_id:  new FormControl(''),
    site_status:  new FormControl(''),
  });

  sendMessageForm = new FormGroup({    
    reminder_type: new FormControl('', Validators.required),
    sms_temp: new FormControl(''),
    sms_gateway: new FormControl(''),
    email_temp: new FormControl(''),
    email_gateway: new FormControl(''),
  });
    

  displayedColumns: string[] = ['Select', 'LeadId', 'SiteId', 'ContactPerson', 'ContactNumber',  
  'Email', 'SmsSent', 'EmailSend', 'LeadSource', 'LeadStatus', 'Status', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;
  leadSelection = new SelectionModel<any>(true, []);

  constructor(private titleService: Title,
    public leadService: LeadService,
    private dialog: MatDialog,
    private loading : LoadingService,
    private notificationService: NotificationService,
    private dialogService : DialogService,) {
  }

  ngOnInit() {
    this.titleService.setTitle('Leads');
    this.onFetchSites();
  }

  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data=> {
      console.log(data);
      this.siteList = data['site_list'];
      this.emailTemplateList = data['email_temp_list'];
        this.smsTemplateList = data['sms_temp_list'];
      this.loading.spin$.next(false);
    });
  }

  onChangeSite(ob) {
    this.loading.spin$.next(true);
    let site_id = ob.value;
    var result = this.leadService.get_lead_campaigns_by_site(site_id).subscribe(data=> {
      console.log(data);
      this.leadCampList = data['lead_campaigns'];
      this.loading.spin$.next(false);
    });
  }

  searchFormSubmit(){
    if(this.searchForm.valid){
      this.loading.spin$.next(true);
      var result = this.leadService.searchLeads(this.searchForm.value).subscribe(data=> {
        console.log(data['dataList']);
        this.dataSource = new MatTableDataSource<any>(data['dataList']);
        this.dataSource.paginator = this.paginator;
        this.onSearchClear();
        this.leadSelection.clear();
        // this.isDownload = this.searchForm.value.step;
        // this.targetUrl = this.esignCamp.filter(x => x.id == this.searchForm.value.campaign)[0]['target_url'];
        this.loading.spin$.next(false);
      });
    }
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  onLoadLeads() {
    //console.log('ok');
    this.leadService.get_site_leads().subscribe(data=> {
      //console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['dataList']);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.leadSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle2() {
    this.isAllSelected() ?
    this.leadSelection.clear() :
    this.dataSource.data.forEach(row => this.leadSelection.select(row));
  }

  masterToggle() {
    if(this.isAllSelected())  {
      this.leadSelection.clear()
    }
    else  {
      let startIndex = (this.dataSource.paginator.pageIndex * this.dataSource.paginator.pageSize);
      let endIndex = (this.dataSource.paginator.pageSize * (this.dataSource.paginator.pageIndex + 1));
      for (let index = startIndex; index < endIndex; index++) {
        this.leadSelection.select(this.dataSource.data[index]);
      }
    }
  }

  onToggleStatus(lead_id)
  {
    this.dialogService.openConfirmDialog('Are you sure to want to continue ?').afterClosed().subscribe(res =>{
      if(res) 
      {
        this.loading.spin$.next(true);
        var result = this.leadService.toggle_site_lead_status(lead_id).subscribe(data=> {
          //console.log(data);
          if(JSON.stringify(data['status'])=='true') 
          {
            this.searchFormSubmit();           
            this.loading.spin$.next(false);
            this.notificationService.success(data['message']);
          }
          else
          {
            this.notificationService.error(JSON.stringify(data['error_message']));
            this.loading.spin$.next(false);
          }
        });
      }
    }); 
  }

  onLeadCreate() 
  {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "70%";
    matDialogConfig.position = { top: '70px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);
    this.dialog.open(CreateLeadDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.searchFormSubmit();
    });
  }

  importLeads()
  {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";    
    matDialogConfig.position = { top: '0px' }
    this.dialog.open(UploadCsvLeadsDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.searchFormSubmit();
    });
  }

  createLeadTagging(lead_id) 
  {
    this.leadService.populateForm(lead_id);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "90%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = {lead_id: lead_id};
    //this.dialog.open(CreateLeadTaggingDialog, matDialogConfig);
    this.dialog.open(CreateLeadTaggingDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.searchFormSubmit();
    });
  }

  reminderTypeChanged(){
    this.reminderType = this.sendMessageForm.value.reminder_type;
    //console.log(this.reminderType);
    if(this.reminderType=="SMS"){
      this.sendMessageForm.get('email_temp').setValidators(null);
      this.sendMessageForm.get('email_gateway').setValidators(null);
      this.sendMessageForm.get('sms_temp').setValidators(Validators.required);
      this.sendMessageForm.get('sms_gateway').setValidators(Validators.required);
    }
    if(this.reminderType=="Email"){
      this.sendMessageForm.get('sms_temp').setValidators(null);
      this.sendMessageForm.get('sms_gateway').setValidators(null);
      this.sendMessageForm.get('email_temp').setValidators(Validators.required);
      this.sendMessageForm.get('email_gateway').setValidators(Validators.required);
    }
  }

  onShowEmailContent(ob)
  {
    var data = this.emailTemplateList.filter(x => x.id === ob.value);
    if(data.length>0)
    {
      this.emailContent = data[0]['temp_content'];
      console.log(this.emailContent);
    }
    else
    {
      this.emailContent = null;
    }
  }

  onShowSMSTemp(ob)
  {
    var data = this.smsTemplateList.filter(x => x.id === ob.value);
    if(data.length>0)
    {
      this.smsContent = data[0]['temp_content'];
      console.log(this.smsContent);
    }
    else
    {
      this.smsContent = null;
    }
  }

  sendMessageFormSubmit() {
    if(this.leadSelection.selected.length>0){
      if(this.sendMessageForm.valid){
        //this.loading.spin$.next(true);
        console.log(this.leadSelection.selected.length);
        var result = this.leadService.sendMessage(this.sendMessageForm.value, this.leadSelection.selected).subscribe(data=> {
          console.log(data);
          if(JSON.stringify(data['status'])=='true') {            
            this.notificationService.success(data['msg']);
            this.loading.spin$.next(false);
            this.leadSelection.clear();
          }
          else {
            this.notificationService.error(JSON.stringify(data['error_message']));
            this.loading.spin$.next(false);
          } 
        });
      }
    }
    else{
      this.notificationService.error('Please Select Leads!!');
      this.loading.spin$.next(false);
    }
  }

}


/* Import Esign Leads Dialog */

@Component({
  selector: 'upload-csv-leads-dialog',
  templateUrl: 'upload-lead-dialog.html',
})
export class UploadCsvLeadsDialog {

  siteList = [];
  leadCampList: any = [];

  uploadForm : FormGroup = new FormGroup({
    site_id: new FormControl('',Validators.required),
    campaign_id: new FormControl(''),
    campaign_name: new FormControl(''),
    file_name: new FormControl(''),
    lead_source: new FormControl(''),
    target_url: new FormControl('', Validators.required),
    csvLeadData: new FormControl('', Validators.required),
    csvLeadHeader: new FormControl('', Validators.required),
  });

  CSVLeadData = [];
  CSVLeadHeader = [];
  isCreateCampaign: boolean = false;

  constructor(
    private loading : LoadingService,
    public leadService: LeadService,
    private papa: Papa,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<LeadsComponent>) { 
  }

  ngOnInit() {
    this.onFetchSites();
  }

  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data=> {
      console.log(data);
      this.siteList = data['site_list'];
      this.loading.spin$.next(false);
    });
  }

  onFetchCampaign(ob) {
    this.loading.spin$.next(true);
    let site_id = ob.value;
    var result = this.leadService.get_lead_campaigns_by_site(site_id).subscribe(data=> {
      console.log(data);
      this.leadCampList = data['lead_campaigns'];
      this.loading.spin$.next(false);
    });
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    var reader = new FileReader();
    reader.readAsText(file);
    reader.onload = (event: any) => {
      var csv = event.target.result;
      this.papa.parse(csv, {
        skipEmptyLines: true,
        header: false,
        complete: (results) => {
          this.CSVLeadData = results.data;
          this.CSVLeadHeader = results.data.splice(0, 1)[0];
          console.log(this.CSVLeadHeader);
          console.log(this.CSVLeadData);
          /*
          for (let i = 0; i < results.data.length; i++) {
            let leadDetails = {
              claim_des: results.data[i].ClaimDescription,
              source_id: results.data[i].SourceID,
              policy_no: results.data[i].PolicyNo,
              claim_reference: results.data[i].ClaimReference,
              title: results.data[i].Title,
              first_name: results.data[i].FirstName,
              last_name: results.data[i].LastName,
              email: results.data[i].Email,
              phone: results.data[i].Mobile,
              address: results.data[i].Address,
              town: results.data[i].Town,
              post_code: results.data[i].Postcode,
              dob: results.data[i].DOB,
            };
           this.CSVLeadData.push(leadDetails);
          }
          */
          //console.log(this.CSVLeadData);
          //console.log(results.data);
        }
      });
    }
  }

  onImportFormSubmit() {
    console.log(this.CSVLeadData);
    if(this.CSVLeadData) {
      let error = 0;
      if(this.isCreateCampaign==true)
      {
        if(this.uploadForm.value.campaign_name.length==0){
          error = error + 1 ;
          this.notificationService.warn('Please enter your campaign name');
        }
        else {
          error = 0;
        }
      }

      if(this.CSVLeadData.length==0) {
        error = error + 1 ;
        this.notificationService.warn('Please upload CSV File with valid data format!!');
      }
      else {
        this.uploadForm.controls['csvLeadData'].setValue(this.CSVLeadData);
        this.uploadForm.controls['csvLeadHeader'].setValue(this.CSVLeadHeader);
      }
      //console.log(this.uploadForm.value);
      if(this.uploadForm.valid && error==0)
      {
        //this.loading.spin$.next(true);
        var result = this.leadService.importLeads(this.uploadForm.value).subscribe(data=> {
          console.log(data);
          if(JSON.stringify(data['status'])=='true') {
            this.notificationService.success(data['message']);
            //this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(JSON.stringify(data['error_message']));
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        //this.notificationService.error('Form Validation Error!!');
      }
    }
    else {
      this.notificationService.error('Please upload your csv file!!');
    }
  }

  onClose(){
    this.uploadForm.reset();
    this.uploadForm.setValue({
      campaign_id: '',
      campaign_name: '',
      site_id: '',
      lead_source: '',
      file_name: '',
      target_url: '',
      csvLeadData: [],
      csvLeadHeader: []
    });
    this.dialogRef.close();
  }

  

  onSetCampaign(ob) {
    let Campaign = ob.value;
    if(Campaign==0){
      this.isCreateCampaign = true;
      this.uploadForm.controls['target_url'].setValue('');
    }
    else {
      //console.log(this.esignCamp);
      let camp = this.leadCampList.find(x=> x.id == Campaign);
      this.uploadForm.controls['target_url'].setValue(camp.target_url);
      this.isCreateCampaign = false;
    }
  }

  

}





/* Create Lead */

@Component({
  selector: 'create-lead-dialog',
  templateUrl: 'create-lead-dialog.html',
  styleUrls: ['./leads.component.css']
})
export class CreateLeadDialog {

  constructor(private dialogRef: MatDialogRef<LeadsComponent>,
    public leadService: LeadService,
    private loading : LoadingService,
    private notificationService: NotificationService,) {
    }

    ngOnInit() {
      
    }

    onClose(){
      this.leadService.lead_form.reset();
      this.dialogRef.close();
    }


    onLeadAddedFormSubmit(formData: any)
    {
      //console.log(formData);
      if (this.leadService.lead_form.valid)
      {
        this.loading.spin$.next(true);
        this.leadService.insert_lead_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success('Lead Data Created Successfully.');  
            this.leadService.lead_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else 
          {
            this.notificationService.error('Lead Data could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
    } 



}  

  





/* Create Lead Tagging */

@Component({
  selector: 'create-lead-tagging-dialog',
  templateUrl: 'create-lead-tagging-dialog.html',
  styleUrls: ['./leads.component.css']
})
export class CreateLeadTaggingDialog {

  lead_details: any;

  displayedColumns: string[] = ['LeadId', 'TaggingType', 'CallbackDate', 'Remarks',  
  'UserId', 'CreatedAt'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;
  lead_id: number = 0;

  constructor(private dialogRef: MatDialogRef<LeadsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public leadService: LeadService,
    private loading : LoadingService,
    private notificationService: NotificationService) {
      this.lead_id = data.lead_id;
    }

    ngOnInit() {
      this.onLoadLeadsTagging();
      this.get_lead_by_id(this.lead_id);
    }

    get_lead_by_id(lead_id) {
      var result = this.leadService.get_lead_by_id(lead_id).subscribe(data=>{
        //console.log(data);
        if(data['status']){
          this.lead_details = data['lead_details'];
          //console.log(this.lead_details);
        }
        else{
          this.notificationService.error(data['error_message']);
        }
      });
    }

    onLoadLeadsTagging() 
    {
      this.leadService.get_lead_taggings(this.lead_id).subscribe(data=> {
        //console.log(data);
        this.dataSource = new MatTableDataSource<any>(data['tagging_list']);
        this.dataSource.paginator = this.paginator;
        this.loading.spin$.next(false);
      });
    }

  
  onLeadTaggingAddedFormSubmit(formData: any)
  {
    //console.log(formData);
    if (this.leadService.lead_tagging_data_form.valid)
    {
      this.loading.spin$.next(true);
      this.leadService.insert_lead_tagging_details(formData).subscribe(data=>{
        //console.log(data);
        if (data['status']) 
        {
          this.notificationService.success('Lead Tagging Data Created Successfully.');  
          this.leadService.lead_tagging_data_form.reset();
          this.onClose();
          this.loading.spin$.next(false);
        }
        else 
        {
          this.notificationService.error('Lead Tagging Data could not be created, Try Again!');
          this.loading.spin$.next(false);
        }
      });
    }
  }  


  onClose()
  {
    // console.log('Close');
    this.leadService.lead_tagging_data_form.reset();
    this.dialogRef.close();
  }
  
  applyFilter(){
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }

  

}  

  

